
import { Grid } from '@mui/material';
import { useEffect, useMemo } from 'react';
import Dialog, { IDefaultDialogProps } from '../../Dialog';
import { ActionButton } from '../../Button';
import { useLanguageContext } from '../../../contexts/LanguageContext';
import DefaultConstants from '../../../data/Constants';
import useState from '../../../hooks/useState';
import IServiceOrder from '../../../interfaces/IServiceOrder';
import SelectField from '../../SelectField';
import { ServicePriorityData } from '../../../data/Enums';


interface IUpdatePriorityDialogProps extends IDefaultDialogProps {
    serviceOrder: IServiceOrder;
    handleSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
}

interface IStateValues {
    priorityId: number;
}

const UpdatePriorityDialog: React.FC<IUpdatePriorityDialogProps> = ({
    open,
    handleClose,
    serviceOrder,
    handleSubmit
}) => {
    const { translate } = useLanguageContext();

    const state = useState<IStateValues>({
        priorityId: 0
    });


    useEffect(() => {
        if (open) {
            state.update('priorityId', +(serviceOrder.priorityId ?? 0));
        }
        // eslint-disable-next-line
    }, [open]);
    

    const dialogActions = useMemo(() => {
        return [
            <ActionButton action='cancel' onClick={handleClose} />,
            <ActionButton action='save' type='submit' />
        ];
        // eslint-disable-next-line
    }, [translate]);

    
    return (
        <Dialog
            open={open}
            handleClose={handleClose}
            title={translate('editPriority')}
            dialogActions={dialogActions}
            onSubmit={handleSubmit}
            className='dialogactions-spacebetween overflow-inherit'
            absolute={true}
            dividers={true}
        >
            <Grid container rowSpacing={DefaultConstants.gridRowSpacing}>
                <Grid item xs={12}>
                    <SelectField
                        label={translate('priority')}
                        name='priorityId'
                        value={state.values.priorityId}
                        onChange={e => state.update(e.target.name, e.target.value)}
                        data={Object.values(ServicePriorityData).map(s => {
                            return {
                                value: +s.key,
                                text: translate(s.name)
                            };
                        })}
                    />
                </Grid>
            </Grid>
        </Dialog>
    );
}

export default UpdatePriorityDialog;